// Navbar.js
import React from "react";
import { Button } from "primereact/button";
import { Menubar } from "primereact/menubar";
import { NavLink } from "react-router-dom";
import pesil from "../assets/logo/pesil.jpg";
import ibmBP from "../assets/logo/ibm-bp.jpg";
export default function Navbar({ darkMode, setDarkMode }) {
  const end = (
    <Button
      icon={darkMode ? "pi pi-sun" : "pi pi-moon"}
      className="p-button-rounded p-button-text"
      onClick={() => setDarkMode(!darkMode)}
    />
  );

  const itemTemplate = (item) => (
    <NavLink
      to={item.to}
      className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
      style={{ textDecoration: "none" }}
    >
      {item.label}
    </NavLink>
  );

  const items = [
    { label: "Home", to: "/" },
    { label: "About Us", to: "/about" },
    { label: "Products", to: "/products" },
    { label: "Services", to: "/services" },
    { label: "Trainings", to: "/trainings" },
    { label: "Contact Us", to: "/contact" },
  ].map((item) => ({
    ...item,
    template: itemTemplate,
  }));

  const start = (
    <>
      <img alt="logo" src={pesil} height="40" className="mr-2" />
      <img src={ibmBP} height="40" className="mr-2" />
    </>
  );

  return (
    <div className="app-navbar">
      <Menubar model={items} start={start} end={end} />
    </div>
  );
}
